import { BASVURU_STATE_ZAMANLARI_LISTELE } from "../constants/requestUrls";
import { postRequest } from "../request";

const basvuruStateZamanlariList = (props) => {
    let data ={};
    if(props !== undefined)
    data = JSON.stringify(props);
    return postRequest({url:BASVURU_STATE_ZAMANLARI_LISTELE,data});
}

export default basvuruStateZamanlariList;